module.exports = __webpack_public_path__ + "static/media/carouselBgHome2.00188f18.jpg";